var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _rect2, _g3, _rect3, _g4, _rect4, _g5, _path17, _rect5, _g6, _rect6, _g7, _rect7, _g8, _g9, _g10, _g11, _g12, _rect8, _g13, _rect9, _path18, _rect10, _g14, _path19, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _rect11, _g15, _path20, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _rect12, _g16, _g17, _g18, _g19, _rect13, _g20, _g21, _g22, _g23, _path21, _rect14, _rect15, _rect16, _rect17, _rect18, _g24, _path22, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _rect19, _g25, _path23, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _rect20, _g26, _g27, _rect21, _g28, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g29, _g30, _g31, _g32, _g33, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g34, _g35, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g36, _path75, _g37, _g38, _g39, _path76, _path77, _path78, _path79, _g40, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _g41;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerImgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10374",
    "data-name": "Group 10374",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1039.719,
    height: 770.169,
    viewBox: "0 0 1039.719 770.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 1039.719,
    height: 770.169,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 555.931,
    height: 70.01,
    fill: "#242c32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_489",
    "data-name": "Rectangle 489",
    width: 66.282,
    height: 323.207,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_492",
    "data-name": "Rectangle 492",
    width: 6.899,
    height: 317.704,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495",
    "data-name": "Rectangle 495",
    width: 35.311,
    height: 323.207,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 3.72,
    height: 317.704,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501",
    "data-name": "Rectangle 501",
    width: 44.516,
    height: 3.002,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504",
    "data-name": "Rectangle 504",
    width: 39.648,
    height: 2.998,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507",
    "data-name": "Rectangle 507",
    width: 18.011,
    height: 27.271,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509",
    "data-name": "Rectangle 509",
    width: 1.133,
    height: 5.703,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    width: 1.132,
    height: 5.703,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_513",
    "data-name": "Rectangle 513",
    width: 1.621,
    height: 8.136,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_515",
    "data-name": "Rectangle 515",
    width: 1.616,
    height: 8.136,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_518",
    "data-name": "Rectangle 518",
    width: 13.089,
    height: 30.273,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    width: 7.411,
    height: 207.48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 4,
    height: 207.48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 34.503,
    height: 4.377,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 34.503,
    height: 4.386,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_532",
    "data-name": "Rectangle 532",
    width: 34.503,
    height: 4.379,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 4.275,
    height: 26.72,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    width: 4.887,
    height: 26.72,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    width: 25.706,
    height: 6.859,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_541",
    "data-name": "Rectangle 541",
    width: 25.706,
    height: 6.861,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    "data-name": "Rectangle 550",
    width: 7.411,
    height: 324.666,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 4,
    height: 324.666,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 6.861,
    height: 34.504,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 55.228,
    height: 41.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 36.17,
    height: 41.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 11.536,
    height: 4.985,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 73.472,
    height: 69.215,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 330.453,
    height: 97.537,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 40.507,
    height: 110.583,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 34.202,
    height: 0.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 94.44,
    height: 59.503,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 4.062,
    height: 1.479,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 15.682,
    height: 18.599,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 210.092,
    height: 27.332,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    width: 80.799,
    height: 52.143,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 25.206,
    height: 9.315,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 266.987,
    height: 27.109,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 93.176,
    height: 58.702,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10343",
    "data-name": "Group 10343",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10222",
    "data-name": "Group 10222",
    transform: "translate(162.337 670.136)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10221",
    "data-name": "Group 10221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10220",
    "data-name": "Group 10220",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27600",
    "data-name": "Path 27600",
    d: "M845.288,1229.485c0,19.334-124.451,35.006-277.964,35.006s-277.969-15.672-277.969-35.006,124.449-35,277.969-35,277.964,15.672,277.964,35",
    transform: "translate(-289.356 -1194.482)",
    fill: "#273c73"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27601",
    "data-name": "Path 27601",
    d: "M1156.62,482.4c-1.119.562-2.248,1.119-3.377,1.681-110.683,54.79-234.675,89.47-358.455,92.714-30.89.809-63.419.49-95.971-2.258-90.373-7.657-180.993-34.08-237.476-107.438a157.045,157.045,0,0,1-13.106-20.031C433.465,420.4,426.1,389.9,423.716,359.432,409.522,177.715,636.107,55.109,789.992,42.857a590.008,590.008,0,0,1,317.735,64.895c25.36,13.271,60.471,30.477,75.518,56.35,12.771,21.949-1.187,37.881-19.556,50.745-40.34,28.251,135.879,196.1-7.069,267.555",
    transform: "translate(-185.72 -18.018)",
    fill: "#c3e7fc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27602",
    "data-name": "Path 27602",
    d: "M1172.924,613.593c-110.682,54.79-234.675,89.471-358.455,92.714-30.89.81-63.419.49-95.971-2.258-90.373-7.657-180.993-34.081-237.475-107.437a157.027,157.027,0,0,1-13.107-20.031C493.356,438.573,672.1,347.713,797.553,337.715a535.016,535.016,0,0,1,288.132,58.849c23,12.042,54.841,27.64,68.481,51.093,11.576,19.911-1.073,34.346-17.737,46.029-19.923,13.945,18.4,65.446,36.5,119.907",
    transform: "translate(-205.402 -147.529)",
    fill: "#99d7f8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27603",
    "data-name": "Path 27603",
    d: "M629.009,335.364c11.179-8.243-33.86-13.4-33.86-13.4s12.371-6.181,12.888-12.881-29.088-5.674-29.088-5.674,8.471-6.7-5.884-13.075-21.069,0-21.069,0-4.268-16.306-24.715-17.039S516,298,516,298s-8.48-7.476-17.149-4.9c-28.257,3.091-.734,27.833-.734,27.833s-26.68-1.548-49.561,8.153c0,0-24.846,9.373,69.375,11.951s111.075-5.674,111.075-5.674",
    transform: "translate(-241.916 -119.963)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27604",
    "data-name": "Path 27604",
    d: "M1222.826,503.226c11.176-8.242-33.859-13.4-33.859-13.4s12.369-6.181,12.886-12.881-29.089-5.674-29.089-5.674,8.47-6.7-5.883-13.075-21.07,0-21.07,0-4.267-16.306-24.714-17.039-11.276,24.708-11.276,24.708-8.482-7.476-17.152-4.9c-28.255,3.091-.732,27.833-.732,27.833s-26.68-1.546-49.56,8.153c0,0-24.852,9.376,69.374,11.953s111.075-5.674,111.075-5.674",
    transform: "translate(-456.272 -193.649)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27605",
    "data-name": "Path 27605",
    d: "M1113.052,62.093c11.182-8.245-33.858-13.4-33.858-13.4s12.371-6.18,12.89-12.881-29.09-5.674-29.09-5.674,8.471-6.7-5.881-13.075-21.071,0-21.071,0S1031.774.753,1011.326.021s-11.277,24.708-11.277,24.708-8.48-7.476-17.15-4.9c-28.257,3.091-.735,27.833-.735,27.833s-26.677-1.546-49.557,8.153c0,0-24.85,9.376,69.375,11.953s111.07-5.674,111.07-5.674",
    transform: "translate(-373.279 6.545)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27606",
    "data-name": "Path 27606",
    d: "M1691.022,339.86c11.177-8.245-33.859-13.4-33.859-13.4s12.371-6.181,12.887-12.887-29.087-5.668-29.087-5.668,8.47-6.7-5.881-13.074-21.074,0-21.074,0-4.265-16.307-24.715-17.039-11.276,24.708-11.276,24.708-8.482-7.475-17.15-4.9c-28.255,3.091-.734,27.833-.734,27.833s-26.68-1.546-49.56,8.154c0,0-24.847,9.375,69.376,11.953s111.073-5.674,111.073-5.674",
    transform: "translate(-661.797 -121.936)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27607",
    "data-name": "Path 27607",
    d: "M1013.644,252.074l.592-63.742h-5.043l-.6,63.742Z",
    transform: "translate(-442.745 -82.675)",
    fill: "#96afd3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27608",
    "data-name": "Path 27608",
    d: "M1020.44,252.074l-.793-63.742h-1.46l-.592,63.742Z",
    transform: "translate(-446.695 -82.675)",
    fill: "#699ac1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 127.634,
    height: 391.98,
    transform: "translate(506.235 258.082)",
    fill: "#96afd3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27609",
    "data-name": "Path 27609",
    d: "M913.166,397.289l-10.832,35.193h79.377l10.835-35.193Z",
    transform: "translate(-396.098 -174.401)",
    fill: "#96afd3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27610",
    "data-name": "Path 27610",
    d: "M1054.653,397.289l-10.835,35.193v391.98h48.256V432.483l-14.5-35.193Z",
    transform: "translate(-458.206 -174.401)",
    fill: "#699ac1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27611",
    "data-name": "Path 27611",
    d: "M995.078,381.679l6.144-19.951h-52.2l-6.144,19.951Z",
    transform: "translate(-413.898 -158.791)",
    fill: "#96afd3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27612",
    "data-name": "Path 27612",
    d: "M1065.351,381.679l-8.223-19.951h-15.067l-6.144,19.951Z",
    transform: "translate(-454.738 -158.791)",
    fill: "#699ac1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27613",
    "data-name": "Path 27613",
    d: "M995.078,346.116l6.144-19.954h-52.2l-6.144,19.954Z",
    transform: "translate(-413.898 -143.179)",
    fill: "#96afd3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27614",
    "data-name": "Path 27614",
    d: "M1065.351,346.116l-8.223-19.954h-15.067l-6.144,19.954Z",
    transform: "translate(-454.738 -143.179)",
    fill: "#699ac1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27615",
    "data-name": "Path 27615",
    d: "M1010.352,310.545l1.577-19.959H998.517l-1.579,19.959Z",
    transform: "translate(-437.627 -127.562)",
    fill: "#96afd3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27616",
    "data-name": "Path 27616",
    d: "M1028.409,310.545l-2.114-19.959h-3.87l-1.577,19.959Z",
    transform: "translate(-448.123 -127.562)",
    fill: "#699ac1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10225",
    "data-name": "Group 10225",
    transform: "translate(513.16 269.173)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10224",
    "data-name": "Group 10224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10223",
    "data-name": "Group 10223",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_488",
    "data-name": "Rectangle 488",
    width: 66.279,
    height: 323.207,
    transform: "translate(0.001)",
    fill: "#699ac1"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    "data-name": "Rectangle 490",
    width: 62.405,
    height: 317.706,
    transform: "translate(513.7 271.921)",
    fill: "#89cddb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10228",
    "data-name": "Group 10228",
    transform: "translate(518.662 271.922)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10227",
    "data-name": "Group 10227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10226",
    "data-name": "Group 10226",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_491",
    "data-name": "Rectangle 491",
    width: 6.899,
    height: 317.706,
    transform: "translate(0 -0.002)",
    fill: "#fff"
  }))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 6.03,
    height: 317.706,
    transform: "translate(541.167 271.921)",
    fill: "#56b8c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10231",
    "data-name": "Group 10231",
    transform: "translate(592.093 269.173)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10230",
    "data-name": "Group 10230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10229",
    "data-name": "Group 10229",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 35.308,
    height: 323.207,
    transform: "translate(0.001)",
    fill: "#699ac1"
  }))))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496",
    "data-name": "Rectangle 496",
    width: 33.653,
    height: 317.706,
    transform: "translate(592.095 271.921)",
    fill: "#56b8c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10234",
    "data-name": "Group 10234",
    transform: "translate(594.769 271.922)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10233",
    "data-name": "Group 10233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10232",
    "data-name": "Group 10232",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    width: 3.719,
    height: 317.706,
    transform: "translate(0.002 -0.002)",
    fill: "#fff"
  }))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27617",
    "data-name": "Path 27617",
    d: "M1108.864,484.687V796.981H1108v5.411h4.126V484.687Z",
    transform: "translate(-486.381 -212.766)",
    fill: "#38afb9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 36.03,
    height: 27.271,
    transform: "translate(526.342 622.79)",
    fill: "#3e86ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10237",
    "data-name": "Group 10237",
    transform: "translate(522.101 619.789)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10236",
    "data-name": "Group 10236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10235",
    "data-name": "Group 10235",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 44.513,
    height: 3.001,
    transform: "translate(0.001 0)",
    fill: "#fff"
  }))))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502",
    "data-name": "Rectangle 502",
    width: 3.086,
    height: 3.001,
    transform: "translate(563.528 619.789)",
    fill: "#699ac1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10240",
    "data-name": "Group 10240",
    transform: "translate(589.131 616.791)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10239",
    "data-name": "Group 10239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10238",
    "data-name": "Group 10238",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_503",
    "data-name": "Rectangle 503",
    width: 39.645,
    height: 2.998,
    transform: "translate(0.002)",
    fill: "#fff"
  }))))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_505",
    "data-name": "Rectangle 505",
    width: 2.75,
    height: 2.998,
    transform: "translate(626.027 616.791)",
    fill: "#699ac1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10243",
    "data-name": "Group 10243",
    transform: "translate(544.358 622.79)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10242",
    "data-name": "Group 10242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10241",
    "data-name": "Group 10241",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506",
    "data-name": "Rectangle 506",
    width: 18.013,
    height: 27.271,
    fill: "#3e86ae"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10246",
    "data-name": "Group 10246",
    transform: "translate(541.645 633.645)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10245",
    "data-name": "Group 10245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10244",
    "data-name": "Group 10244",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508",
    "data-name": "Rectangle 508",
    width: 1.133,
    height: 5.703,
    transform: "translate(0)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10249",
    "data-name": "Group 10249",
    transform: "translate(546.241 633.645)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10248",
    "data-name": "Group 10248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10247",
    "data-name": "Group 10247",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_510",
    "data-name": "Rectangle 510",
    width: 1.132,
    height: 5.703,
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10252",
    "data-name": "Group 10252",
    transform: "translate(604.834 626.648)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10251",
    "data-name": "Group 10251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10250",
    "data-name": "Group 10250",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_512",
    "data-name": "Rectangle 512",
    width: 1.619,
    height: 8.136,
    transform: "translate(0.001)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10255",
    "data-name": "Group 10255",
    transform: "translate(611.387 626.648)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10254",
    "data-name": "Group 10254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10253",
    "data-name": "Group 10253",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_514",
    "data-name": "Rectangle 514",
    width: 1.616,
    height: 8.136,
    transform: "translate(0.001)",
    fill: "#fff"
  }))))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_516",
    "data-name": "Rectangle 516",
    width: 26.188,
    height: 30.272,
    transform: "translate(595.827 619.789)",
    fill: "#3e86ae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10258",
    "data-name": "Group 10258",
    transform: "translate(608.924 619.789)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10257",
    "data-name": "Group 10257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10256",
    "data-name": "Group 10256",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_517",
    "data-name": "Rectangle 517",
    width: 13.094,
    height: 30.272,
    transform: "translate(-0.003 0.001)",
    fill: "#3e86ae"
  }))))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 137.169,
    height: 269.201,
    transform: "translate(810.937 370.553)",
    fill: "#ba98c7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27618",
    "data-name": "Path 27618",
    d: "M1649.364,880.905H1597.5V611.7l51.861-62.356Z",
    transform: "translate(-701.257 -241.151)",
    fill: "#8e6cab"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    width: 67.069,
    height: 218.191,
    transform: "translate(818.96 380.056)",
    fill: "#8478b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10261",
    "data-name": "Group 10261",
    transform: "translate(824.292 383.242)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10260",
    "data-name": "Group 10260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10259",
    "data-name": "Group 10259",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_521",
    "data-name": "Rectangle 521",
    width: 7.411,
    height: 207.48,
    transform: "translate(0.002)",
    fill: "#fff"
  }))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27619",
    "data-name": "Path 27619",
    d: "M1520.308,677.432V891.9h-60.563v3.719h67.069V677.432Z",
    transform: "translate(-640.786 -297.376)",
    fill: "#2f3887"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 218.191,
    transform: "translate(852.494 380.056)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y2: 218.191,
    transform: "translate(868.534 380.056)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    y2: 218.191,
    transform: "translate(833.578 380.056)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x1: 67.069,
    transform: "translate(818.959 489.151)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x1: 67.069,
    transform: "translate(818.959 473.214)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x1: 67.069,
    transform: "translate(818.959 457.27)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x1: 67.069,
    transform: "translate(818.959 441.333)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 67.069,
    transform: "translate(818.959 425.392)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x1: 67.069,
    transform: "translate(818.959 409.455)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x1: 67.069,
    transform: "translate(818.959 393.511)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x1: 67.069,
    transform: "translate(818.959 584.788)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 67.069,
    transform: "translate(818.959 568.851)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x1: 67.069,
    transform: "translate(818.959 552.91)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x1: 67.069,
    transform: "translate(818.959 536.967)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x1: 67.069,
    transform: "translate(818.959 521.03)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x1: 67.069,
    transform: "translate(818.959 505.095)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_523",
    "data-name": "Rectangle 523",
    width: 36.167,
    height: 218.191,
    transform: "translate(903.211 380.056)",
    fill: "#2f3887"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10264",
    "data-name": "Group 10264",
    transform: "translate(906.084 383.242)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10263",
    "data-name": "Group 10263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10262",
    "data-name": "Group 10262",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_524",
    "data-name": "Rectangle 524",
    width: 3.999,
    height: 207.48,
    transform: "translate(0.001)",
    fill: "#fff"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27620",
    "data-name": "Path 27620",
    d: "M1642.579,677.432V891.9h-32.66v3.719h36.166V677.432Z",
    transform: "translate(-706.708 -297.376)",
    fill: "#213181"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y2: 218.191,
    transform: "translate(916.41 380.056)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y2: 218.191,
    transform: "translate(927.944 380.056)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x1: 36.167,
    transform: "translate(903.211 489.151)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x1: 36.167,
    transform: "translate(903.211 473.214)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x1: 36.167,
    transform: "translate(903.211 457.27)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x1: 36.167,
    transform: "translate(903.211 441.333)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x1: 36.167,
    transform: "translate(903.211 425.392)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 36.167,
    transform: "translate(903.211 409.455)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x1: 36.167,
    transform: "translate(903.211 393.511)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x1: 36.167,
    transform: "translate(903.211 584.788)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x1: 36.167,
    transform: "translate(903.211 568.851)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x1: 36.167,
    transform: "translate(903.211 552.91)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x1: 36.167,
    transform: "translate(903.211 536.967)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x1: 36.167,
    transform: "translate(903.211 521.03)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x1: 36.167,
    transform: "translate(903.211 505.095)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 55.228,
    height: 26.72,
    transform: "translate(824.294 613.034)",
    fill: "#5f4490"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10267",
    "data-name": "Group 10267",
    transform: "translate(833.577 616.029)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10266",
    "data-name": "Group 10266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10265",
    "data-name": "Group 10265",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 34.504,
    height: 4.377,
    transform: "translate(0.001)",
    fill: "#5f4490"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10270",
    "data-name": "Group 10270",
    transform: "translate(833.577 624.791)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10269",
    "data-name": "Group 10269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10268",
    "data-name": "Group 10268",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 34.504,
    height: 4.386,
    transform: "translate(0.001)",
    fill: "#5f4490"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10273",
    "data-name": "Group 10273",
    transform: "translate(833.577 633.561)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10272",
    "data-name": "Group 10272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10271",
    "data-name": "Group 10271",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 34.504,
    height: 4.379,
    transform: "translate(0.001)",
    fill: "#5f4490"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10276",
    "data-name": "Group 10276",
    transform: "translate(875.25 613.034)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10275",
    "data-name": "Group 10275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10274",
    "data-name": "Group 10274",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    width: 4.27,
    height: 26.72,
    transform: "translate(0.002)",
    fill: "#5f4490"
  }))))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    width: 36.167,
    height: 26.72,
    transform: "translate(903.211 613.034)",
    fill: "#5f4490"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10279",
    "data-name": "Group 10279",
    transform: "translate(934.489 613.034)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10278",
    "data-name": "Group 10278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10277",
    "data-name": "Group 10277",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_536",
    "data-name": "Rectangle 536",
    width: 4.888,
    height: 26.72,
    transform: "translate(0.001)",
    fill: "#5f4490"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10282",
    "data-name": "Group 10282",
    transform: "translate(906.084 602.626)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10281",
    "data-name": "Group 10281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10280",
    "data-name": "Group 10280",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_538",
    "data-name": "Rectangle 538",
    width: 25.705,
    height: 6.859,
    transform: "translate(0.002)",
    fill: "#5f4490"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10285",
    "data-name": "Group 10285",
    transform: "translate(906.084 616.341)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10284",
    "data-name": "Group 10284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10283",
    "data-name": "Group 10283",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_540",
    "data-name": "Rectangle 540",
    width: 25.705,
    height: 6.861,
    transform: "translate(0.002)",
    fill: "#5f4490"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10288",
    "data-name": "Group 10288",
    transform: "translate(906.084 630.058)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10287",
    "data-name": "Group 10287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10286",
    "data-name": "Group 10286",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_542",
    "data-name": "Rectangle 542",
    width: 25.705,
    height: 6.859,
    transform: "translate(0.002)",
    fill: "#5f4490"
  }))))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27621",
    "data-name": "Path 27621",
    d: "M1530.755,611.7l51.861-62.355h-85.311L1445.447,611.7Z",
    transform: "translate(-634.51 -241.151)",
    fill: "#d5bddd"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_544",
    "data-name": "Rectangle 544",
    width: 89.329,
    height: 10.307,
    transform: "translate(807.629 639.754)",
    fill: "#ba98c7"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_545",
    "data-name": "Rectangle 545",
    width: 56.067,
    height: 10.307,
    transform: "translate(896.958 639.754)",
    fill: "#8e6cab"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_546",
    "data-name": "Rectangle 546",
    width: 137.168,
    height: 421.257,
    transform: "translate(674.365 228.804)",
    fill: "#94a3d4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_547",
    "data-name": "Rectangle 547",
    width: 51.858,
    height: 421.257,
    transform: "translate(759.675 228.804)",
    fill: "#6583c1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_548",
    "data-name": "Rectangle 548",
    width: 67.066,
    height: 341.442,
    transform: "translate(682.388 243.675)",
    fill: "#75caf5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10291",
    "data-name": "Group 10291",
    transform: "translate(687.72 248.668)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10290",
    "data-name": "Group 10290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10289",
    "data-name": "Group 10289",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_549",
    "data-name": "Rectangle 549",
    width: 7.413,
    height: 324.668,
    transform: "translate(0.001 -0.002)",
    fill: "#fff"
  }))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27622",
    "data-name": "Path 27622",
    d: "M1276.877,434.341V769.959h-60.562v5.824h67.066V434.341Z",
    transform: "translate(-533.927 -190.666)",
    fill: "#00b2ed"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    y2: 341.442,
    transform: "translate(715.921 243.675)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x1: 67.066,
    transform: "translate(682.388 414.396)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x1: 67.066,
    transform: "translate(682.388 389.455)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x1: 67.066,
    transform: "translate(682.388 364.51)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x1: 67.066,
    transform: "translate(682.388 339.569)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x1: 67.066,
    transform: "translate(682.388 314.622)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x1: 67.066,
    transform: "translate(682.388 289.677)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x1: 67.066,
    transform: "translate(682.388 264.736)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x1: 67.066,
    transform: "translate(682.388 564.051)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x1: 67.066,
    transform: "translate(682.388 539.109)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x1: 67.066,
    transform: "translate(682.388 514.165)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x1: 67.066,
    transform: "translate(682.388 489.223)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x1: 67.066,
    transform: "translate(682.388 464.282)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x1: 67.066,
    transform: "translate(682.388 439.338)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 36.168,
    height: 341.442,
    transform: "translate(766.637 243.675)",
    fill: "#00b2ed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10294",
    "data-name": "Group 10294",
    transform: "translate(769.513 248.668)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10293",
    "data-name": "Group 10293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10292",
    "data-name": "Group 10292",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 3.999,
    height: 324.668,
    transform: "translate(0.002 -0.002)",
    fill: "#fff"
  }))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27623",
    "data-name": "Path 27623",
    d: "M1399.144,434.341V769.959h-32.659v5.824h36.168V434.341Z",
    transform: "translate(-599.847 -190.666)",
    fill: "#0082ca"
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    y2: 341.442,
    transform: "translate(784.723 243.675)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x1: 36.168,
    transform: "translate(766.637 414.396)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x1: 36.168,
    transform: "translate(766.637 389.455)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x1: 36.168,
    transform: "translate(766.637 364.51)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x1: 36.168,
    transform: "translate(766.637 339.569)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x1: 36.168,
    transform: "translate(766.637 314.622)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x1: 36.168,
    transform: "translate(766.637 289.677)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x1: 36.168,
    transform: "translate(766.637 264.736)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x1: 36.168,
    transform: "translate(766.637 564.051)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x1: 36.168,
    transform: "translate(766.637 539.109)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x1: 36.168,
    transform: "translate(766.637 514.165)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x1: 36.168,
    transform: "translate(766.637 489.223)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x1: 36.168,
    transform: "translate(766.637 464.282)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x1: 36.168,
    transform: "translate(766.637 439.338)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 55.227,
    height: 41.804,
    transform: "translate(687.72 608.257)",
    fill: "#3567af"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10297",
    "data-name": "Group 10297",
    transform: "translate(690.144 610.748)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10296",
    "data-name": "Group 10296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10295",
    "data-name": "Group 10295",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 6.861,
    height: 34.504,
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10300",
    "data-name": "Group 10300",
    transform: "translate(687.72 608.256)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10299",
    "data-name": "Group 10299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10298",
    "data-name": "Group 10298",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27624",
    "data-name": "Path 27624",
    d: "M1276.683,1084.185v37.855H1225.82v3.95h55.226v-41.8Z",
    transform: "translate(-1225.82 -1084.185)",
    fill: "#3567af"
  }))))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 36.168,
    height: 41.804,
    transform: "translate(766.637 608.257)",
    fill: "#3567af"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10303",
    "data-name": "Group 10303",
    transform: "translate(766.635 608.256)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10302",
    "data-name": "Group 10302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10301",
    "data-name": "Group 10301",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27625",
    "data-name": "Path 27625",
    d: "M1397.607,1084.185v37h-31.122v4.809h36.168v-41.8Z",
    transform: "translate(-1366.482 -1084.185)",
    fill: "#3567af"
  }))))), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    y1: 41.804,
    transform: "translate(715.335 608.257)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x2: 55.227,
    transform: "translate(687.721 629.159)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x2: 55.227,
    transform: "translate(687.721 617.606)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x2: 55.227,
    transform: "translate(687.721 640.68)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    y1: 41.804,
    transform: "translate(784.721 608.257)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    x2: 36.168,
    transform: "translate(766.637 629.159)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    x2: 36.168,
    transform: "translate(766.637 617.606)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x2: 36.168,
    transform: "translate(766.637 640.68)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.7
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27626",
    "data-name": "Path 27626",
    d: "M443.14,783.973c.214,0,3.566-.589,3.726-.589s7.451-8.026,13.682-8.38-18.166,1.3-18.166,1.3Z",
    transform: "translate(-194.193 -340.185)",
    fill: "#12162c"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27627",
    "data-name": "Path 27627",
    d: "M746.081,773.256s11.6,7.22,16.707,13.467,9.082,2.917,9.082,2.675a78.719,78.719,0,0,0-4.054-7.055c-.325-.245-10.46-6.815-10.705-6.9s-11.029-2.188-11.029-2.188",
    transform: "translate(-327.508 -339.44)",
    fill: "#12162c"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27628",
    "data-name": "Path 27628",
    d: "M639.939,786.36s-8.946-13.441-22.857-16.682C518.791,746.74,416.2,771.615,416.2,771.615l-5.929,7.773,18.577.213s5.407-8.223,8.519-8.874c52.905-11.039,157.157-9.615,174.631,2.618,5.868,4.1,8.127,8.012,8.127,8.012Z",
    transform: "translate(-180.098 -333.604)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27629",
    "data-name": "Path 27629",
    d: "M1217.354,1163.824s1.847,20.6,6.063,20.438,3.243-5.3,5.675-6.542,9.246-5.783,9.246-5.783l-18-12.374Z",
    transform: "translate(-534.383 -509.017)",
    fill: "#12162c"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27630",
    "data-name": "Path 27630",
    d: "M1070.829,1086.97a48.062,48.062,0,1,1-48.065-48.063,48.063,48.063,0,0,1,48.065,48.063",
    transform: "translate(-427.867 -456.053)",
    fill: "#12162c"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27631",
    "data-name": "Path 27631",
    d: "M1129.286,1115.414l-30.223,7.274-68.121-6.92-29.093.981s-8.937-35.834-7.208-41.935,3.334-50.952,40.357-49.935,63.941-4.463,76.237,3.48,25.769,49.381,25.481,50.814-7.43,36.24-7.43,36.24",
    transform: "translate(-436.521 -449.499)",
    fill: "#12162c"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27632",
    "data-name": "Path 27632",
    d: "M304.616,1067.859l22.23,10.705,69.093,12.651,33.571,4.362s9.732-29.664,9.246-35.986,6.813-50.6-29.678-56.926-61.794-17.031-75.418-11.682-35.032,43.307-35.032,44.768,5.99,32.109,5.99,32.109",
    transform: "translate(-131.088 -434.379)",
    fill: "#12162c"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27633",
    "data-name": "Path 27633",
    d: "M863.545,994.687c4.822-18.166,7.1-51.734-26.2-95.38-7.309-9.579-19.127-16.46-34.754-20.612-43.749-11.642-99.026-21.277-99.026-21.277-16.461-9.946-101.937-61.479-107.987-63.445-39.375-12.783-89.391-18.06-122.4-18.276-91.047-.585-133.582,12.683-133.582,12.683l-.872,14.49c-22.857,20.557-36.681,71.408-42.205,118.079-.268,2.263-5.46,5.259-5.821,7.381-3.032,17.982-.519,37.665,3.63,46.326,1.92,4,5.6,7.42,10.52,10.338A61.221,61.221,0,0,1,424.931,1001.7l267.415,6.051a61.214,61.214,0,0,1,122.323-1.977l.511,3.237c12.541.865,50.387-4.973,50.387-4.973v-5.619s-1.58-.859-3.362-1.8a4.044,4.044,0,0,0,1.341-1.937",
    transform: "translate(-127.019 -340.503)",
    fill: "#fff"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10306",
    "data-name": "Group 10306",
    transform: "translate(557.47 594.473)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10305",
    "data-name": "Group 10305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10304",
    "data-name": "Group 10304",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27634",
    "data-name": "Path 27634",
    d: "M1005.195,1062.111c0,1.649-1.594,2.491-3.243,2.491s-8.295-.352-8.295-2,7.677-2.981,9.325-2.981,2.213.844,2.213,2.494",
    transform: "translate(-993.657 -1059.617)",
    fill: "#111e72"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10309",
    "data-name": "Group 10309",
    transform: "translate(665.818 599.382)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10308",
    "data-name": "Group 10308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10307",
    "data-name": "Group 10307",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27635",
    "data-name": "Path 27635",
    d: "M1257.49,1123.169c3.192-12.028,5.265-30.809-3.364-54.8a34.568,34.568,0,0,1-2.805,6.152,31.667,31.667,0,0,1-6.62,8.171,43.677,43.677,0,0,1-12.276,7.317,38.553,38.553,0,0,1-9.7,2.549,81.453,81.453,0,0,1-17.061.789,143.244,143.244,0,0,1-18.054-2.528c-.276-.055-.55-.112-.827-.17a61.077,61.077,0,0,1,21.83,43.609l.511,3.238c12.541.865,50.387-4.973,50.387-4.973V1126.9s-1.58-.859-3.362-1.8a4.044,4.044,0,0,0,1.341-1.937",
    transform: "translate(-1186.782 -1068.368)",
    fill: "#111e72"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10312",
    "data-name": "Group 10312",
    transform: "translate(236.501 446.759)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10311",
    "data-name": "Group 10311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10310",
    "data-name": "Group 10310",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27636",
    "data-name": "Path 27636",
    d: "M752,873.021s-76.122-58.688-129.97-70.555-188.829-5.374-198.381,9.549,15.856,47.358,27.966,52.547,237.562,31.14,255.73,29.2S750.918,875.645,752,873.021",
    transform: "translate(-421.548 -796.326)",
    fill: "#111e72"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10315",
    "data-name": "Group 10315",
    transform: "translate(162.337 533.908)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10314",
    "data-name": "Group 10314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10313",
    "data-name": "Group 10313",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27637",
    "data-name": "Path 27637",
    d: "M317.617,1000.25a117.268,117.268,0,0,1-3.054-17.385,119.434,119.434,0,0,1,.506-31.2c-3.726.977-7.394,2.188-11.081,3.312a400.1,400.1,0,0,0-7.473,43.226c-.268,2.263-5.461,5.259-5.821,7.381-3.033,17.981-.519,37.664,3.629,46.325,1.92,4,5.6,7.42,10.521,10.339a61.289,61.289,0,0,1,25.019-34.191,89.475,89.475,0,0,1-6.189-11.749,125.324,125.324,0,0,1-6.057-16.058",
    transform: "translate(-289.355 -951.664)",
    fill: "#111e72"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10318",
    "data-name": "Group 10318",
    transform: "translate(493.037 665.445)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10317",
    "data-name": "Group 10317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10316",
    "data-name": "Group 10316",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27638",
    "data-name": "Path 27638",
    d: "M913.01,1187.063c-.986-.291-1.964-.6-2.929-.943-10.424.17-20.847.191-31.273.17Z",
    transform: "translate(-878.808 -1186.121)",
    fill: "#111e72"
  }))))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27639",
    "data-name": "Path 27639",
    d: "M342.068,910.073c12.391-6.458,19.879-47.764-7.23-47.5-.235,0-.467.006-.7.009-7.9,14.732-14.13,33.466-18.76,53.414,7.6-.5,19.017-1.929,26.689-5.919",
    transform: "translate(-138.442 -378.645)",
    fill: "#f88f00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27640",
    "data-name": "Path 27640",
    d: "M364.4,819.307a5.237,5.237,0,0,0-.8-1.562c-11.267,7.75-20.536,22.652-27.885,41.147,5.389.589,21.208-1.943,21.208-1.943l8.632-3.1s-1.3-34.058-1.152-34.545",
    transform: "translate(-147.367 -358.969)",
    fill: "#181e3f"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27641",
    "data-name": "Path 27641",
    d: "M376.534,796.284l-3.023,50.1c4.679-.816,9.745-1.565,14.958-2.125,0,0-3.859-36.6-1.433-50.578-7.041,1.528-10.5,2.6-10.5,2.6",
    transform: "translate(-163.96 -348.407)",
    fill: "#12162c"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27642",
    "data-name": "Path 27642",
    d: "M1085.818,949.695s61.846,46.57,113.383,59.475c0,0-7.259-30.485-23.252-38.454-35.652-17.777-90.131-21.021-90.131-21.021",
    transform: "translate(-476.643 -416.891)",
    fill: "#12162c"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27643",
    "data-name": "Path 27643",
    d: "M854.874,876.091s-76.659-52.55-101.208-60.331-72.99-15.128-76.125-12.614,10.812,69.92,10.812,69.92-1.561-.031,124.783,20.511c10.195,1.661,41.738-17.486,41.738-17.486",
    transform: "translate(-297.219 -352.341)",
    fill: "#12162c"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27644",
    "data-name": "Path 27644",
    d: "M566.485,871.3s-98.229-11.466-105.453-12.548-24.905-38.912-18.225-45.621,116.972-11.279,119.46-8.99,4.218,67.159,4.218,67.159",
    transform: "translate(-193.73 -352.736)",
    fill: "#12162c"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27645",
    "data-name": "Path 27645",
    d: "M434.3,1135.487a48.386,48.386,0,1,1-48.385-48.387,48.387,48.387,0,0,1,48.385,48.387",
    transform: "translate(-148.165 -477.208)",
    fill: "#181e3f"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27646",
    "data-name": "Path 27646",
    d: "M432.1,1140.618c.554.179,1.122.3,1.679.462.088-.915.149-1.845.18-2.78a.911.911,0,0,1-.633.256h-.947a.936.936,0,0,1,0-1.871h.947a.95.95,0,0,1,.666.28c0-.127,0-.259,0-.39,0-.887-.03-1.77-.081-2.643a1,1,0,0,1-.208.084c-.585.173-1.153.386-1.742.554a.936.936,0,0,1-.5-1.8c.585-.173,1.156-.38,1.741-.554a.858.858,0,0,1,.575.012q-.076-.831-.18-1.661a.944.944,0,0,1-1.284-.027.934.934,0,0,1,0-1.32c.307-.262.645-.478.972-.709a46.928,46.928,0,0,0-1.417-5.9,1.121,1.121,0,0,1-.4.5c-.108.069-.21.139-.314.213,0,.006-.006.006-.009.009a.143.143,0,0,0-.031.029,1.212,1.212,0,0,0-.11.093,2.65,2.65,0,0,0-.256.259c-.02.02-.1.127-.095.111-.012.017-.023.037-.036.054a.96.96,0,0,1-1.282.337.942.942,0,0,1-.333-1.283,5.384,5.384,0,0,1,1.521-1.438.9.9,0,0,1,.987.032,46.859,46.859,0,0,0-2.324-5.631,5.8,5.8,0,0,0-.693.4c-.311.213-.586.5-.594.7-.055,1.205-1.926,1.211-1.871,0,.061-1.369,1.165-2.185,2.3-2.762a46.057,46.057,0,0,0-2.631-4.29c-.023.014-.046.029-.069.041a2.066,2.066,0,0,0-.94.922.937.937,0,0,1-1.28.34.963.963,0,0,1-.333-1.283,3.4,3.4,0,0,1,1.545-1.513,44.528,44.528,0,0,0-3.028-3.647.791.791,0,0,1-.242.2,2.065,2.065,0,0,0-.709.539,1.886,1.886,0,0,0-.363.565.954.954,0,0,1-1.151.651.941.941,0,0,1-.654-1.153,4.056,4.056,0,0,1,1.825-2.154q-1.051-1.06-2.168-2.047a.933.933,0,0,1-1.787-.536,3.02,3.02,0,0,1,.268-.759q-1.185-.961-2.425-1.842a.1.1,0,0,0-.029.021c-.069.043-.139.091-.206.141a.406.406,0,0,1-.034.026c-.111.092-.227.187-.333.291a4.156,4.156,0,0,0-.317.32c-.027.028-.05.061-.075.086a.209.209,0,0,1-.041.058.953.953,0,0,1-1.283.34.938.938,0,0,1-.333-1.277,5.339,5.339,0,0,1,1.037-1.113c-.77-.5-1.556-.971-2.353-1.424-.35.366-.726.707-1.087,1.059a.935.935,0,0,1-1.323-1.321c.229-.227.464-.45.7-.672-1.044-.539-2.113-1.038-3.2-1.5a4.339,4.339,0,0,1-1.075,1.513.948.948,0,0,1-1.322,0,.929.929,0,0,1,0-1.32,2.934,2.934,0,0,0,.673-.889c-.736-.276-1.485-.533-2.24-.776a5.517,5.517,0,0,1-.986,1.8c-.82.888-2.139-.438-1.321-1.323a3.144,3.144,0,0,0,.568-1c-.93-.265-1.872-.487-2.829-.695a5.819,5.819,0,0,1-.619,2.036.935.935,0,0,1-1.615-.943,4.008,4.008,0,0,0,.421-1.439c-.942-.164-1.9-.3-2.863-.4a.706.706,0,0,1-.038.271,9.126,9.126,0,0,1-.435,1.427,1.583,1.583,0,0,1-1.9.723.934.934,0,0,1,.328-1.83c.065-.251.108-.51.186-.758q-1.609-.112-3.244-.11c-.265,0-.525,0-.787.009a14.678,14.678,0,0,1-.15,1.964.939.939,0,0,1-1.15.648.951.951,0,0,1-.655-1.15,9.046,9.046,0,0,0,.093-1.4q-1.192.064-2.369.193c0,.008,0,.02,0,.032.017.839.254,1.781-.285,2.526a.959.959,0,0,1-1.28.337.947.947,0,0,1-.334-1.286.449.449,0,0,0,.1-.2,4.239,4.239,0,0,0,0-.47c-.016-.236-.037-.464-.049-.7a46.947,46.947,0,0,0-6.106,1.315c.022.36.056.721.107,1.076a.954.954,0,0,1-.655,1.147.934.934,0,0,1-1.15-.646c-.048-.34-.1-.672-.132-1.009q-1.59.528-3.128,1.167c.34.984.764,2.007-.154,2.777s-2.228-.519-1.339-1.3a.806.806,0,0,0-.031-.21c-.045-.176-.1-.355-.153-.534a46.9,46.9,0,0,0-5.459,2.972c.242.6.506,1.2.742,1.8a.939.939,0,0,1-.653,1.15.956.956,0,0,1-1.152-.657c-.167-.42-.343-.836-.519-1.257q-1.6,1.108-3.1,2.344a5.365,5.365,0,0,1,.761,1.5.936.936,0,0,1-1.8.5,3.283,3.283,0,0,0-.379-.8,47.434,47.434,0,0,0-3.929,3.933,8.855,8.855,0,0,1,.8,1.2.957.957,0,0,1-.334,1.286.945.945,0,0,1-1.28-.337,5.944,5.944,0,0,0-.433-.686c-.733.887-1.43,1.807-2.093,2.747a9.855,9.855,0,0,0,.96.85.95.95,0,0,1,.334,1.275.936.936,0,0,1-1.281.34,12.817,12.817,0,0,1-1.068-.9c-.377.582-.735,1.177-1.084,1.773a1.7,1.7,0,0,1,.274.369.96.96,0,0,1-.337,1.286.993.993,0,0,1-.875.031c-.491.929-.959,1.878-1.388,2.843.366.115.732.245,1.089.39a.961.961,0,0,1,.655,1.15.937.937,0,0,1-1.151.657c-.435-.176-.878-.334-1.326-.472a47.45,47.45,0,0,0-1.851,5.645c.643.161,1.289.3,1.938.452,1.176.271.674,2.079-.5,1.805-.626-.144-1.252-.283-1.872-.435-.3,1.4-.54,2.828-.715,4.281.627.257,1.271.473,1.886.767a.942.942,0,0,1,.334,1.28.959.959,0,0,1-1.28.34c-.37-.185-.752-.331-1.137-.482-.1,1.243-.149,2.494-.149,3.762q0,1.319.074,2.629c.163.006.33.006.5.006a.938.938,0,0,1,0,1.874c-.119,0-.238-.006-.356-.006a46.425,46.425,0,0,0,.871,5.578c.576-.147,1.168-.242,1.765-.349,1.182-.21,1.685,1.595.5,1.8-.612.109-1.233.194-1.828.352.2.781.426,1.548.667,2.315a26.424,26.424,0,0,1,2.809-.288.938.938,0,0,1,0,1.874,18.165,18.165,0,0,0-2.2.208,46.605,46.605,0,0,0,3.18,6.942,4.5,4.5,0,0,1,2.5-.907c1.206-.043,1.2,1.825,0,1.868a2.671,2.671,0,0,0-1.555.643,47.164,47.164,0,0,0,4.179,5.777,8.861,8.861,0,0,0,2.079-.349c1.159-.36,1.65,1.444.5,1.8a8.524,8.524,0,0,1-1.063.254c1.015,1.084,2.079,2.125,3.189,3.11a10.272,10.272,0,0,0,2.442-1.877c.823-.879,2.145.45,1.326,1.329a11.409,11.409,0,0,1-2.263,1.825,47.425,47.425,0,0,0,5.249,3.719,9.942,9.942,0,0,1,1.589-2.021c.88-.828,2.206.5,1.324,1.323a8.244,8.244,0,0,0-1.3,1.637,46.581,46.581,0,0,0,4.989,2.4,5.014,5.014,0,0,1,1.208-1.986.935.935,0,0,1,1.324,1.32,3.464,3.464,0,0,0-.82,1.338,46.329,46.329,0,0,0,5.523,1.638,9.516,9.516,0,0,1,.781-1.479c.669-1,2.289-.058,1.619.949a7.2,7.2,0,0,0-.523.922,47.4,47.4,0,0,0,6.432.755,11.131,11.131,0,0,1,.286-2.823.937.937,0,0,1,1.8.5,9.17,9.17,0,0,0-.233,2.38c.144,0,.288.006.432.006q2.072,0,4.1-.185c.151-.978.317-1.949.535-2.912.262-1.176,2.066-.674,1.8.5-.163.726-.3,1.464-.419,2.205a46.132,46.132,0,0,0,6.71-1.364c-.3-1.127-1.125-2.108-1.35-3.273s1.576-1.68,1.805-.5a24.586,24.586,0,0,0,1.277,3.249,46.62,46.62,0,0,0,6.424-2.623,15.389,15.389,0,0,0-1.889-2.136c-.885-.822.441-2.145,1.326-1.323a17.391,17.391,0,0,1,2.239,2.589,47.717,47.717,0,0,0,4.269-2.652l-.372-.26c-.983-.683-.049-2.309.946-1.617q.506.359,1.029.706,1.48-1.133,2.86-2.366a5.356,5.356,0,0,1-1.587-1.906.953.953,0,0,1,.335-1.277.936.936,0,0,1,1.28.332,4.35,4.35,0,0,0,1.337,1.579,46.735,46.735,0,0,0,4.006-4.393c-1.16-.833-2.4-1.454-2.945-2.892-.425-1.133,1.384-1.614,1.806-.5a2.932,2.932,0,0,0,1.216,1.217c.353.234.7.464,1.052.712a47.227,47.227,0,0,0,2.724-4.126.768.768,0,0,1-.549-.262c-.578-.689-1.206-1.33-1.791-2a.952.952,0,0,1,0-1.324.938.938,0,0,1,1.323,0c.586.678,1.215,1.318,1.791,2,.026.035.047.067.072.1a46.825,46.825,0,0,0,2.353-5.057c-.831-.213-1.661-.421-2.489-.643a.936.936,0,0,1,.5-1.8c.879.234,1.764.461,2.645.686.48-1.373.9-2.777,1.253-4.2a1.025,1.025,0,0,1-1.038.061c-.681-.329-1.423-.516-2.106-.845a.936.936,0,1,1,.941-1.617c.683.331,1.427.516,2.111.845a.767.767,0,0,1,.363.38q.4-1.829.666-3.716a.546.546,0,0,1-.063-.015c-.626-.2-1.274-.323-1.9-.525-1.142-.368-.652-2.174.5-1.8",
    transform: "translate(-149.257 -478.297)",
    fill: "#12162c"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27647",
    "data-name": "Path 27647",
    d: "M431.185,1146.689a34.069,34.069,0,1,1-34.068-34.069,34.068,34.068,0,0,1,34.068,34.069",
    transform: "translate(-159.367 -488.411)",
    fill: "#bababa"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27648",
    "data-name": "Path 27648",
    d: "M389.482,1132.46s.7-.948,1.505-.43,3.411,6.2,2.768,7.45-2.854,2.03-3.18,1.075-1.394-6.6-1.093-8.1",
    transform: "translate(-170.948 -496.863)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27649",
    "data-name": "Path 27649",
    d: "M395.1,1127.918s-1.126.343-.9,1.272,4.7,5.285,6.1,5.1,2.865-2.01,2.071-2.638-5.754-3.519-7.266-3.734",
    transform: "translate(-173.028 -495.126)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27650",
    "data-name": "Path 27650",
    d: "M447.236,1129.182s1.083.473.761,1.37-5.26,4.734-6.627,4.388-2.624-2.312-1.767-2.851,6.109-2.857,7.633-2.906",
    transform: "translate(-192.85 -495.681)",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27651",
    "data-name": "Path 27651",
    d: "M455.758,1133.651s-.591-1.02-1.447-.594-4.077,5.778-3.578,7.1,2.612,2.332,3.045,1.418,2.115-6.409,1.98-7.926",
    transform: "translate(-197.836 -497.337)",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27652",
    "data-name": "Path 27652",
    d: "M468.094,1179.106s.078,1.176-.871,1.3-6.6-2.531-6.922-3.906.869-3.388,1.735-2.871,5.325,4.14,6.057,5.481",
    transform: "translate(-202.035 -515.154)",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27653",
    "data-name": "Path 27653",
    d: "M465.79,1189.66s.64-.986-.13-1.557-7-1-7.949.046-.89,3.382.122,3.35,6.667-1.027,7.957-1.84",
    transform: "translate(-200.625 -521.285)",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27654",
    "data-name": "Path 27654",
    d: "M425.524,1221s-1.159.222-1.4-.7,1.7-6.865,3.024-7.355,3.474.449,3.061,1.373-3.454,5.795-4.691,6.683",
    transform: "translate(-186.171 -532.391)",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27655",
    "data-name": "Path 27655",
    d: "M416.407,1220.017s1.061.514,1.533-.323.134-7.069-1.021-7.879-3.47-.467-3.313.534,1.841,6.487,2.8,7.669",
    transform: "translate(-181.558 -531.755)",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27656",
    "data-name": "Path 27656",
    d: "M375.3,1188.015s-.582-1.023.218-1.546,7.046-.6,7.933.5.691,3.431-.314,3.338-6.595-1.413-7.837-2.295",
    transform: "translate(-164.658 -520.667)",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27657",
    "data-name": "Path 27657",
    d: "M373.458,1177.653s-.144,1.17.794,1.347,6.74-2.142,7.137-3.494-.672-3.439-1.567-2.973-5.554,3.832-6.364,5.121",
    transform: "translate(-163.934 -514.681)",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27658",
    "data-name": "Path 27658",
    d: "M398.608,1116.32a31.856,31.856,0,1,1-31.855,31.858,31.858,31.858,0,0,1,31.855-31.858m0-.309a32.165,32.165,0,1,0,32.164,32.167,32.2,32.2,0,0,0-32.164-32.167",
    transform: "translate(-160.859 -489.899)",
    fill: "#12162c"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27659",
    "data-name": "Path 27659",
    d: "M427.22,1160.941a15.85,15.85,0,1,1-15.848-15.854,15.85,15.85,0,0,1,15.848,15.854",
    transform: "translate(-173.622 -502.663)",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27660",
    "data-name": "Path 27660",
    d: "M426.851,1162.265A14.158,14.158,0,1,1,412.7,1148.1a14.158,14.158,0,0,1,14.156,14.161",
    transform: "translate(-174.946 -503.987)",
    fill: "#bababa"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27661",
    "data-name": "Path 27661",
    d: "M425.008,1151.784c-.391-.571-4.69-.695-4.69-.695s-4.3.124-4.691.695,4.691,3.578,4.691,3.578,5.08-3.009,4.69-3.578",
    transform: "translate(-182.439 -505.298)",
    fill: "#12162c"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27662",
    "data-name": "Path 27662",
    d: "M441.72,1167.7c.434-.548-.756-4.745-.756-4.745s-1.417-4.112-2.089-4.319-2.034,5.613-2.034,5.613,4.444,4.005,4.878,3.451",
    transform: "translate(-191.761 -508.61)",
    fill: "#12162c"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27663",
    "data-name": "Path 27663",
    d: "M401.843,1167.7c-.435-.548.752-4.745.752-4.745s1.42-4.112,2.09-4.319,2.038,5.613,2.038,5.613-4.448,4.005-4.881,3.451",
    transform: "translate(-176.355 -508.61)",
    fill: "#12162c"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27664",
    "data-name": "Path 27664",
    d: "M430.649,1188.378c.677.173,4.032-2.609,4.032-2.609s3.191-2.961,3.111-3.653-5.961.4-5.961.4-1.861,5.679-1.182,5.858",
    transform: "translate(-188.977 -518.816)",
    fill: "#12162c"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27665",
    "data-name": "Path 27665",
    d: "M411.258,1188.378c-.678.173-4.033-2.609-4.033-2.609s-3.192-2.961-3.108-3.653,5.959.4,5.959.4,1.863,5.679,1.182,5.858",
    transform: "translate(-177.395 -518.816)",
    fill: "#12162c"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27666",
    "data-name": "Path 27666",
    d: "M420.992,1167.092a3.235,3.235,0,1,1-3.235,3.238,3.239,3.239,0,0,1,3.235-3.238m0-.617a3.85,3.85,0,1,0,3.847,3.855,3.853,3.853,0,0,0-3.847-3.855",
    transform: "translate(-183.113 -512.052)",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27667",
    "data-name": "Path 27667",
    d: "M426.934,1120.916c-.977-1.43-11.75-1.73-11.75-1.73s-10.775.3-11.756,1.73,11.756,8.963,11.756,8.963,12.73-7.531,11.75-8.963",
    transform: "translate(-177.07 -491.293)",
    fill: "#12162c"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27668",
    "data-name": "Path 27668",
    d: "M468.815,1160.8c1.086-1.379-1.89-11.881-1.89-11.881s-3.556-10.322-5.238-10.835-5.1,14.073-5.1,14.073,11.143,10.027,12.229,8.644",
    transform: "translate(-200.428 -499.585)",
    fill: "#12162c"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27669",
    "data-name": "Path 27669",
    d: "M368.883,1160.8c-1.087-1.379,1.889-11.881,1.889-11.881s3.561-10.322,5.239-10.835,5.1,14.073,5.1,14.073-11.14,10.027-12.229,8.644",
    transform: "translate(-161.824 -499.585)",
    fill: "#12162c"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27670",
    "data-name": "Path 27670",
    d: "M441.067,1212.608c1.7.438,10.105-6.524,10.105-6.524s8-7.424,7.794-9.171-14.937,1.021-14.937,1.021-4.663,14.239-2.963,14.675",
    transform: "translate(-193.452 -525.159)",
    fill: "#12162c"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27671",
    "data-name": "Path 27671",
    d: "M392.48,1212.608c-1.7.438-10.105-6.524-10.105-6.524s-8-7.424-7.793-9.171,14.937,1.021,14.937,1.021,4.664,14.239,2.961,14.675",
    transform: "translate(-164.429 -525.159)",
    fill: "#12162c"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10321",
    "data-name": "Group 10321",
    transform: "translate(191.695 609.892)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10320",
    "data-name": "Group 10320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10319",
    "data-name": "Group 10319",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27672",
    "data-name": "Path 27672",
    d: "M343.577,1121.077c4.207,1.075,8.372,2.283,12.552,3.454,8.422,2.358,16.958,4.278,25.412,6.507,17.9,4.723,35.649,9.99,53.3,15.566a48.395,48.395,0,0,0-93.153-25.988c.63.144,1.263.3,1.892.461",
    transform: "translate(-341.685 -1087.1)",
    fill: "#111e72"
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10324",
    "data-name": "Group 10324",
    transform: "translate(270.606 692.168)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10323",
    "data-name": "Group 10323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10322",
    "data-name": "Group 10322",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27673",
    "data-name": "Path 27673",
    d: "M486.189,1235.233c.07-.069.141-.144.212-.216-1.354-.427-2.709-.839-4.062-1.262,1.281.5,2.565.989,3.85,1.479",
    transform: "translate(-482.339 -1233.754)",
    fill: "#111e72"
  }))))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27674",
    "data-name": "Path 27674",
    d: "M325.606,927.544s-1.081-2.595-7.243-3.243a4.875,4.875,0,0,0-1.091.032,341.378,341.378,0,0,0-8.88,37.961c21.756-15.355,17.215-34.75,17.215-34.75",
    transform: "translate(-135.375 -405.736)",
    fill: "#f88f00"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27675",
    "data-name": "Path 27675",
    d: "M483.967,812.146l-2.27,46.619,100.56,12.147s-1.854-58.786-5.189-62.834c-2.921-3.54-93.1,4.068-93.1,4.068",
    transform: "translate(-211.451 -354.313)",
    fill: "#181e3f"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27676",
    "data-name": "Path 27676",
    d: "M801.085,890.454c.645.069,16.219-12.109,16.219-12.109l-1.946-22.064s-31.817-25.385-56.875-34.816-76.339-14.194-76.339-14.194,6.443,54.421,10.9,65.665c0,0,106.1,17.3,108.041,17.518",
    transform: "translate(-299.441 -354.371)",
    fill: "#181e3f"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27677",
    "data-name": "Path 27677",
    d: "M904.954,941.132s-22.06-3.082-28.871-2.436-4.1,5.451-2.213,7.755,25.589,6.989,26.648,6.9,4.435-12.215,4.435-12.215",
    transform: "translate(-382.656 -412.024)",
    fill: "#12162c"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27678",
    "data-name": "Path 27678",
    d: "M852.9,930.3c.294.355,10.821,6.276,12.635,5.841s11.591-.876,9.3-10.379c-3.027-12.544-10.492-15.13-16.22-14.254-3.295.5-9.718,14.032-5.715,18.792",
    transform: "translate(-373.841 -400.061)",
    fill: "#12162c"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27679",
    "data-name": "Path 27679",
    d: "M858.89,912.984s11.921-3.4,16.382,14.594l-22.22-2.837s1.62-8.839,5.838-11.757",
    transform: "translate(-374.465 -400.664)",
    fill: "#fff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27680",
    "data-name": "Path 27680",
    d: "M462.619,854.4c.323,0,7.026-.268,7.026-.268v19.7l-4.864-.559Z",
    transform: "translate(-203.076 -374.94)",
    fill: "#181e3f"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27681",
    "data-name": "Path 27681",
    d: "M316.989,961.14c-.667,4.206-1.833,7.507-2.6,7.392s-.845-3.633-.176-7.833,1.831-7.51,2.6-7.384.846,3.624.178,7.825",
    transform: "translate(-137.731 -418.479)",
    fill: "#fff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27682",
    "data-name": "Path 27682",
    d: "M323.756,925.354c.089-.26,7.91,0,7.91,0s-1.8,12.718-9.421,12.611c0,0-2.922.4,1.511-12.611",
    transform: "translate(-141.041 -406.156)",
    fill: "#fff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27683",
    "data-name": "Path 27683",
    d: "M379.639,1003.471a10.311,10.311,0,1,1-10.311-10.316A10.311,10.311,0,0,1,379.639,1003.471Z",
    transform: "translate(-157.598 -435.969)",
    fill: "none",
    stroke: "#12162c",
    strokeWidth: 0.482
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10327",
    "data-name": "Group 10327",
    transform: "translate(201.418 559.213)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10326",
    "data-name": "Group 10326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10325",
    "data-name": "Group 10325",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27684",
    "data-name": "Path 27684",
    d: "M363.781,1001.671a20.512,20.512,0,0,1-.586-4.9,10.31,10.31,0,0,0,11.5,17.088c-5.144-2.364-9.532-6.57-10.918-12.184",
    transform: "translate(-359.016 -996.767)",
    fill: "#111e72"
  }))))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27685",
    "data-name": "Path 27685",
    d: "M475.143,901.393s212.367,28.015,251.294,35.526l.865-3.942s-228.587-34.83-252.159-31.584",
    transform: "translate(-208.574 -395.594)",
    fill: "#12162c"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10330",
    "data-name": "Group 10330",
    transform: "translate(324.313 617.612)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10329",
    "data-name": "Group 10329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10328",
    "data-name": "Group 10328",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27686",
    "data-name": "Path 27686",
    d: "M765.479,1126.132c4.879.455,9.795.887,14.679,1.507,1.617.162,2.489.251,2.489.251l-.618-.006c.726.1,5.41.2,6.132.308-.487-3.191-9.622-10.465-9.622-10.465l-200.47-16.866s9.3,6.2,14.056,7.1c3.866.732,127.235,13.432,173.355,18.169",
    transform: "translate(-578.069 -1100.861)",
    fill: "#111e72"
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10333",
    "data-name": "Group 10333",
    transform: "translate(641.761 540.136)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10332",
    "data-name": "Group 10332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10331",
    "data-name": "Group 10331",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27687",
    "data-name": "Path 27687",
    d: "M1201.444,976.453a140.567,140.567,0,0,0-16.885-6.994l-40.424-6.694c-2.053,6.919,9.895,14.435,9.895,14.435,20.951,4.91,32,17.777,37.019,25.651a206.259,206.259,0,0,0,33.648,12.057s-7.26-30.486-23.252-38.455",
    transform: "translate(-1143.898 -962.764)",
    fill: "#fff"
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10336",
    "data-name": "Group 10336",
    transform: "translate(396.727 559.368)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10335",
    "data-name": "Group 10335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10334",
    "data-name": "Group 10334",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27688",
    "data-name": "Path 27688",
    d: "M707.874,997.046s23.465,3.636,24.276,4.287-1.135,5.029-1.135,5.029-12.061-1.785-18.975-2.832c-2.638-.4-4.527-.695-4.707-.744-.647-.161.541-5.74.541-5.74",
    transform: "translate(-707.141 -997.045)",
    fill: "#111e72"
  }))))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27689",
    "data-name": "Path 27689",
    d: "M717.682,1011.621l-1.808-3.018,15.569,2.327-2.162,1.721Z",
    transform: "translate(-314.248 -442.75)",
    fill: "#181e3f"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27690",
    "data-name": "Path 27690",
    d: "M711.983,1010.444a.947.947,0,1,1-.947-.942.943.943,0,0,1,.947.942",
    transform: "translate(-311.709 -443.145)",
    fill: "#181e3f"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27691",
    "data-name": "Path 27691",
    d: "M1011.5,1061.724a2.109,2.109,0,1,1-2.108-2.108,2.11,2.11,0,0,1,2.108,2.108",
    transform: "translate(-442.169 -465.144)",
    fill: "#f88f00"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27692",
    "data-name": "Path 27692",
    d: "M1239,1117.7s6.161,23.194,6.567,27.9,23.924,1.217,25.3,1.217l3.73-9.407s-2.349-20.683-35.6-19.709",
    transform: "translate(-543.887 -490.624)",
    fill: "#12162c"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10339",
    "data-name": "Group 10339",
    transform: "translate(297.778 640.13)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10338",
    "data-name": "Group 10338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10337",
    "data-name": "Group 10337",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27693",
    "data-name": "Path 27693",
    d: "M530.905,1162.065l266.851,6.041c-.913-3.223-3.787-11.17-10.676-14.912-8.758-4.74-245.239-15.035-249.537-11.457-2.289,1.909-4.792,9.252-6.772,16.405.084,1.3.134,2.61.134,3.924",
    transform: "translate(-530.771 -1140.997)",
    fill: "#111e72"
  }))))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27694",
    "data-name": "Path 27694",
    d: "M1188.851,973.633c-.2-.038-1.884,9.289,2.344,11.61s19.961.268,21.446-1.856-13.733-7.908-23.79-9.754",
    transform: "translate(-521.653 -427.399)",
    fill: "#fff"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27695",
    "data-name": "Path 27695",
    d: "M1249.783,1015.44c1.3,5.126-8.783,6.285-10.543,5.9-1.924-.415-3.892-3.347-5.189-8.467s-.8-9.67,1.112-10.155,13.323,7.594,14.62,12.717",
    transform: "translate(-541.396 -440.16)",
    fill: "#fff"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27696",
    "data-name": "Path 27696",
    d: "M1131.628,1153.632a47.736,47.736,0,1,1-47.737-47.735,47.732,47.732,0,0,1,47.737,47.735",
    transform: "translate(-454.843 -485.46)",
    fill: "#181e3f"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27697",
    "data-name": "Path 27697",
    d: "M1129.453,1158.7c.548.173,1.107.291,1.658.455q.125-1.357.178-2.744a.894.894,0,0,1-.623.254h-.937a.923.923,0,1,1,0-1.845h.937a.933.933,0,0,1,.655.277c0-.13,0-.256,0-.386,0-.877-.029-1.747-.079-2.606a1.311,1.311,0,0,1-.2.08c-.577.173-1.142.381-1.717.548a.923.923,0,0,1-.491-1.779c.578-.173,1.142-.38,1.716-.547a.845.845,0,0,1,.571.02c-.052-.56-.109-1.1-.179-1.64a.936.936,0,0,1-1.265-.035.925.925,0,0,1,0-1.306c.3-.251.635-.473.957-.7a46.1,46.1,0,0,0-1.4-5.821,1.011,1.011,0,0,1-.391.482c-.106.072-.208.144-.309.222a.013.013,0,0,0-.009,0c-.01.006-.017.017-.033.029-.036.032-.072.061-.108.089-.088.09-.173.168-.254.26-.016.015-.1.13-.092.106a.334.334,0,0,1-.035.055.945.945,0,0,1-1.263.332.923.923,0,0,1-.332-1.26,5.3,5.3,0,0,1,1.5-1.424.886.886,0,0,1,.975.032,46.308,46.308,0,0,0-2.292-5.559,5.451,5.451,0,0,0-.683.4c-.305.207-.576.5-.585.7-.053,1.185-1.9,1.19-1.847,0,.061-1.358,1.153-2.16,2.268-2.731a46.05,46.05,0,0,0-2.595-4.229.488.488,0,0,0-.07.043,2.022,2.022,0,0,0-.925.905.919.919,0,0,1-1.262.334.949.949,0,0,1-.333-1.263,3.31,3.31,0,0,1,1.527-1.493,46.757,46.757,0,0,0-2.985-3.6.759.759,0,0,1-.242.2,2.043,2.043,0,0,0-.7.533,1.826,1.826,0,0,0-.356.554.941.941,0,0,1-1.139.643.927.927,0,0,1-.643-1.132,4.019,4.019,0,0,1,1.8-2.128c-.693-.695-1.4-1.372-2.139-2.018a.922.922,0,0,1-1.766-.534,3.155,3.155,0,0,1,.265-.744c-.777-.631-1.57-1.245-2.391-1.828a.158.158,0,0,1-.027.032,2.1,2.1,0,0,0-.2.139l-.034.019c-.115.1-.225.188-.332.291a3.615,3.615,0,0,0-.311.318.653.653,0,0,0-.072.087c-.008.012-.02.026-.044.057a.946.946,0,0,1-1.264.335.931.931,0,0,1-.33-1.263,5.331,5.331,0,0,1,1.023-1.1c-.759-.5-1.535-.963-2.323-1.41-.341.363-.715.7-1.07,1.05a.924.924,0,0,1-1.306-1.306c.226-.227.458-.438.689-.663-1.029-.531-2.085-1.021-3.157-1.476a4.426,4.426,0,0,1-1.061,1.493.944.944,0,0,1-1.3,0,.923.923,0,0,1,0-1.306,2.8,2.8,0,0,0,.664-.874c-.725-.274-1.465-.531-2.209-.767a5.5,5.5,0,0,1-.971,1.776c-.81.876-2.113-.433-1.306-1.306a3.074,3.074,0,0,0,.562-.989q-1.379-.385-2.79-.683a5.826,5.826,0,0,1-.612,2.013.923.923,0,0,1-1.594-.929,4.011,4.011,0,0,0,.415-1.424c-.931-.162-1.874-.292-2.823-.4a.8.8,0,0,1-.039.268,8.652,8.652,0,0,1-.43,1.407,1.565,1.565,0,0,1-1.876.721.924.924,0,0,1,.322-1.811c.064-.248.105-.5.186-.741q-1.592-.117-3.2-.116c-.259,0-.519.006-.776.006a14.671,14.671,0,0,1-.15,1.935.918.918,0,0,1-1.136.646.939.939,0,0,1-.644-1.136,8.78,8.78,0,0,0,.092-1.378c-.782.049-1.564.113-2.338.193,0,.008,0,.02,0,.032a3.89,3.89,0,0,1-.283,2.491.94.94,0,0,1-1.262.329.922.922,0,0,1-.332-1.26.457.457,0,0,0,.095-.2,4.191,4.191,0,0,0,0-.464c-.016-.227-.037-.461-.05-.691a47.165,47.165,0,0,0-6.023,1.3c.02.355.053.709.105,1.058a.95.95,0,0,1-.646,1.139.926.926,0,0,1-1.136-.646c-.047-.326-.094-.657-.129-.992-1.048.349-2.074.735-3.086,1.153.335.966.752,1.972-.153,2.739s-2.2-.513-1.32-1.289a.889.889,0,0,0-.032-.2c-.045-.178-.1-.355-.153-.53a46.762,46.762,0,0,0-5.386,2.935c.241.591.5,1.182.731,1.778a.922.922,0,0,1-.644,1.134.941.941,0,0,1-1.134-.643c-.164-.418-.34-.83-.513-1.24-1.055.724-2.072,1.5-3.062,2.309a5.1,5.1,0,0,1,.752,1.482c.35,1.142-1.435,1.62-1.778.49a3.169,3.169,0,0,0-.375-.787,48.306,48.306,0,0,0-3.878,3.881,8.1,8.1,0,0,1,.79,1.188.922.922,0,1,1-1.593.928,6.967,6.967,0,0,0-.422-.683c-.721.879-1.413,1.79-2.067,2.719a9.409,9.409,0,0,0,.944.836.941.941,0,0,1,.333,1.262.93.93,0,0,1-1.264.329,11.839,11.839,0,0,1-1.056-.88q-.554.86-1.068,1.745a1.694,1.694,0,0,1,.271.372.934.934,0,0,1-.334,1.26.955.955,0,0,1-.861.04c-.488.911-.949,1.845-1.373,2.8.364.118.727.242,1.077.386a.95.95,0,0,1,.644,1.142.921.921,0,0,1-1.131.64c-.432-.173-.868-.326-1.31-.464a46.757,46.757,0,0,0-1.825,5.571c.631.163,1.273.3,1.909.446,1.16.265.668,2.044-.49,1.779-.617-.139-1.234-.28-1.845-.43q-.449,2.076-.709,4.221c.62.26,1.257.468,1.861.756a.928.928,0,0,1,.331,1.266.94.94,0,0,1-1.262.332c-.363-.179-.743-.323-1.123-.468-.1,1.223-.147,2.462-.147,3.708,0,.871.026,1.738.074,2.595.161.008.325.008.49.008a.926.926,0,0,1,0,1.851c-.118,0-.233,0-.35-.009a45.874,45.874,0,0,0,.857,5.5c.57-.144,1.154-.239,1.743-.343,1.164-.2,1.662,1.577.493,1.778-.6.109-1.215.193-1.806.344.2.775.422,1.531.661,2.283.922-.107,1.839-.262,2.77-.277a.922.922,0,0,1,0,1.842,19.006,19.006,0,0,0-2.168.208,46.187,46.187,0,0,0,3.134,6.85,4.445,4.445,0,0,1,2.465-.9c1.192-.035,1.185,1.8,0,1.851a2.612,2.612,0,0,0-1.532.631,45.394,45.394,0,0,0,4.121,5.694,8.529,8.529,0,0,0,2.053-.343c1.141-.355,1.624,1.43.49,1.785a9.245,9.245,0,0,1-1.047.248q1.5,1.609,3.148,3.065a9.866,9.866,0,0,0,2.408-1.848c.809-.87,2.113.444,1.306,1.309a11.128,11.128,0,0,1-2.231,1.805,46.883,46.883,0,0,0,5.177,3.668,9.788,9.788,0,0,1,1.569-1.993c.868-.816,2.175.49,1.306,1.306a8.067,8.067,0,0,0-1.284,1.614,46.62,46.62,0,0,0,4.92,2.37,5.024,5.024,0,0,1,1.2-1.966.922.922,0,0,1,1.3,1.3,3.441,3.441,0,0,0-.808,1.323,46.513,46.513,0,0,0,5.446,1.617,9.637,9.637,0,0,1,.774-1.459c.657-.98,2.258-.054,1.594.934a8.407,8.407,0,0,0-.514.911,45.893,45.893,0,0,0,6.347.75,11.121,11.121,0,0,1,.279-2.791.924.924,0,0,1,1.78.5,9.082,9.082,0,0,0-.229,2.344h.427c1.364,0,2.712-.054,4.044-.17.152-.963.316-1.926.529-2.874.262-1.162,2.04-.673,1.779.49-.159.727-.291,1.45-.415,2.18a46.916,46.916,0,0,0,6.622-1.341c-.3-1.119-1.11-2.079-1.331-3.232s1.553-1.658,1.78-.487a24.786,24.786,0,0,0,1.258,3.2,45.02,45.02,0,0,0,6.34-2.589,15.666,15.666,0,0,0-1.86-2.1c-.878-.81.433-2.116,1.3-1.306a17.348,17.348,0,0,1,2.209,2.551,48.012,48.012,0,0,0,4.212-2.615c-.121-.087-.245-.173-.366-.254-.969-.674-.049-2.277.931-1.594.334.23.671.467,1.017.692.972-.738,1.912-1.52,2.823-2.329a5.378,5.378,0,0,1-1.567-1.883.946.946,0,0,1,.33-1.266.923.923,0,0,1,1.263.332,4.391,4.391,0,0,0,1.324,1.56,47.493,47.493,0,0,0,3.953-4.336c-1.148-.822-2.373-1.436-2.906-2.851-.422-1.119,1.363-1.594,1.778-.5a2.9,2.9,0,0,0,1.2,1.2c.349.228.7.455,1.041.7a46.682,46.682,0,0,0,2.686-4.068.75.75,0,0,1-.541-.262c-.571-.672-1.191-1.306-1.768-1.972a.939.939,0,0,1,0-1.3.924.924,0,0,1,1.306,0c.577.666,1.2,1.3,1.767,1.969.023.032.047.066.069.1a46.6,46.6,0,0,0,2.322-4.982c-.819-.213-1.639-.424-2.459-.639a.923.923,0,0,1,.489-1.779c.869.228,1.744.453,2.614.68.475-1.352.884-2.742,1.234-4.146a1.011,1.011,0,0,1-1.022.055c-.673-.317-1.4-.51-2.079-.83a.927.927,0,0,1-.332-1.263.943.943,0,0,1,1.26-.334c.675.323,1.407.514,2.082.836a.739.739,0,0,1,.36.375q.4-1.807.656-3.664a.55.55,0,0,1-.064-.015c-.617-.2-1.255-.326-1.87-.522-1.128-.361-.649-2.145.488-1.779",
    transform: "translate(-455.916 -486.533)",
    fill: "#12162c"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27698",
    "data-name": "Path 27698",
    d: "M1128.551,1164.681a33.612,33.612,0,1,1-33.611-33.614,33.609,33.609,0,0,1,33.611,33.614",
    transform: "translate(-465.891 -496.509)",
    fill: "#bababa"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27699",
    "data-name": "Path 27699",
    d: "M1087.408,1150.648s.691-.934,1.484-.424,3.366,6.115,2.733,7.355-2.817,1.995-3.138,1.058-1.38-6.516-1.078-7.989",
    transform: "translate(-477.317 -504.851)",
    fill: "#fff"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27700",
    "data-name": "Path 27700",
    d: "M1092.953,1146.171s-1.11.334-.893,1.257,4.639,5.215,6.016,5.027,2.826-1.99,2.047-2.606-5.679-3.471-7.17-3.679",
    transform: "translate(-479.37 -503.139)",
    fill: "#fff"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27701",
    "data-name": "Path 27701",
    d: "M1144.391,1147.425s1.065.462.751,1.347-5.19,4.671-6.539,4.33-2.586-2.29-1.744-2.814,6.028-2.822,7.532-2.863",
    transform: "translate(-498.927 -503.689)",
    fill: "#fff"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27702",
    "data-name": "Path 27702",
    d: "M1152.8,1151.824s-.587-1.006-1.428-.585-4.024,5.7-3.529,7.006,2.577,2.3,3,1.4,2.09-6.322,1.956-7.819",
    transform: "translate(-503.846 -505.318)",
    fill: "#fff"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27703",
    "data-name": "Path 27703",
    d: "M1164.964,1196.664s.077,1.162-.858,1.28-6.517-2.494-6.831-3.846.859-3.352,1.715-2.836,5.252,4.082,5.974,5.4",
    transform: "translate(-507.987 -522.896)",
    fill: "#fff"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27704",
    "data-name": "Path 27704",
    d: "M1162.695,1207.082s.629-.977-.128-1.537-6.908-.989-7.842.043-.876,3.341.121,3.306,6.575-1.011,7.849-1.813",
    transform: "translate(-506.599 -528.946)",
    fill: "#fff"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27705",
    "data-name": "Path 27705",
    d: "M1122.968,1238s-1.145.213-1.378-.7,1.676-6.772,2.983-7.251,3.425.441,3.022,1.355-3.408,5.715-4.627,6.6",
    transform: "translate(-492.337 -539.901)",
    fill: "#fff"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27706",
    "data-name": "Path 27706",
    d: "M1113.978,1237.033s1.045.5,1.509-.314.134-6.977-1.008-7.779-3.423-.458-3.265.525,1.812,6.4,2.764,7.568",
    transform: "translate(-487.787 -539.277)",
    fill: "#fff"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27707",
    "data-name": "Path 27707",
    d: "M1073.417,1205.46s-.569-1.018.222-1.531,6.951-.594,7.825.5.681,3.388-.311,3.3-6.507-1.39-7.735-2.26",
    transform: "translate(-471.112 -528.333)",
    fill: "#fff"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27708",
    "data-name": "Path 27708",
    d: "M1071.6,1195.242s-.141,1.153.784,1.329,6.651-2.113,7.043-3.453-.666-3.388-1.547-2.927-5.482,3.776-6.281,5.051",
    transform: "translate(-470.397 -522.433)",
    fill: "#fff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27709",
    "data-name": "Path 27709",
    d: "M1096.414,1134.731a31.426,31.426,0,1,1-31.429,31.426,31.428,31.428,0,0,1,31.429-31.426m0-.3a31.728,31.728,0,1,0,31.731,31.729,31.763,31.763,0,0,0-31.731-31.729",
    transform: "translate(-467.365 -497.984)",
    fill: "#12162c"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27710",
    "data-name": "Path 27710",
    d: "M1124.644,1178.746a15.636,15.636,0,1,1-15.637-15.638,15.637,15.637,0,0,1,15.637,15.638",
    transform: "translate(-479.959 -510.574)",
    fill: "#fff"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27711",
    "data-name": "Path 27711",
    d: "M1124.28,1180.052a13.965,13.965,0,1,1-13.966-13.968,13.964,13.964,0,0,1,13.966,13.968",
    transform: "translate(-481.265 -511.88)",
    fill: "#bababa"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27712",
    "data-name": "Path 27712",
    d: "M1122.459,1169.72c-.388-.565-4.629-.681-4.629-.681s-4.243.115-4.628.681,4.628,3.529,4.628,3.529,5.014-2.964,4.629-3.529",
    transform: "translate(-488.654 -513.177)",
    fill: "#12162c"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27713",
    "data-name": "Path 27713",
    d: "M1138.947,1185.417c.426-.545-.744-4.682-.744-4.682s-1.4-4.063-2.063-4.265-2.008,5.544-2.008,5.544,4.385,3.944,4.815,3.4",
    transform: "translate(-497.851 -516.437)",
    fill: "#12162c"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27714",
    "data-name": "Path 27714",
    d: "M1099.6,1185.417c-.429-.545.744-4.682.744-4.682s1.4-4.063,2.063-4.265,2.007,5.544,2.007,5.544-4.386,3.944-4.813,3.4",
    transform: "translate(-482.652 -516.437)",
    fill: "#12162c"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27715",
    "data-name": "Path 27715",
    d: "M1128.021,1205.819c.669.17,3.977-2.577,3.977-2.577s3.152-2.921,3.072-3.6-5.884.4-5.884.4-1.837,5.6-1.164,5.778",
    transform: "translate(-495.104 -526.509)",
    fill: "#12162c"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27716",
    "data-name": "Path 27716",
    d: "M1108.894,1205.819c-.669.17-3.979-2.577-3.979-2.577s-3.151-2.921-3.064-3.6,5.878.4,5.878.4,1.836,5.6,1.165,5.778",
    transform: "translate(-483.68 -526.509)",
    fill: "#12162c"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27717",
    "data-name": "Path 27717",
    d: "M1118.5,1184.817a3.19,3.19,0,1,1-3.186,3.191,3.193,3.193,0,0,1,3.186-3.191m0-.608a3.8,3.8,0,1,0,3.8,3.8,3.8,3.8,0,0,0-3.8-3.8",
    transform: "translate(-489.323 -519.836)",
    fill: "#fff"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27718",
    "data-name": "Path 27718",
    d: "M1124.364,1139.261c-.969-1.416-11.6-1.713-11.6-1.713s-10.63.3-11.6,1.713,11.6,8.845,11.6,8.845,12.561-7.433,11.6-8.845",
    transform: "translate(-483.359 -499.353)",
    fill: "#12162c"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27719",
    "data-name": "Path 27719",
    d: "M1165.682,1178.615c1.071-1.366-1.866-11.728-1.866-11.728s-3.509-10.177-5.167-10.685-5.03,13.888-5.03,13.888,10.989,9.885,12.063,8.525",
    transform: "translate(-506.406 -507.536)",
    fill: "#12162c"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27720",
    "data-name": "Path 27720",
    d: "M1067.088,1178.615c-1.069-1.366,1.866-11.728,1.866-11.728s3.508-10.177,5.166-10.685,5.034,13.888,5.034,13.888-10.991,9.885-12.065,8.525",
    transform: "translate(-468.318 -507.536)",
    fill: "#12162c"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27721",
    "data-name": "Path 27721",
    d: "M1138.3,1229.729c1.681.424,9.972-6.446,9.972-6.446s7.894-7.321,7.69-9.042-14.738,1.007-14.738,1.007-4.6,14.049-2.924,14.481",
    transform: "translate(-499.52 -532.769)",
    fill: "#12162c"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27722",
    "data-name": "Path 27722",
    d: "M1090.367,1229.729c-1.679.424-9.971-6.446-9.971-6.446s-7.894-7.321-7.687-9.042,14.737,1.007,14.737,1.007,4.6,14.049,2.922,14.481",
    transform: "translate(-470.886 -532.769)",
    fill: "#12162c"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10342",
    "data-name": "Group 10342",
    transform: "translate(583.61 620.437)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10341",
    "data-name": "Group 10341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10340",
    "data-name": "Group 10340",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27723",
    "data-name": "Path 27723",
    d: "M1042.118,1139.416c4.151,1.058,8.263,2.258,12.386,3.411,8.309,2.33,16.73,4.218,25.071,6.424,17.653,4.65,35.172,9.848,52.581,15.349a47.744,47.744,0,0,0-91.9-25.636c.621.145,1.244.3,1.864.453",
    transform: "translate(-1040.252 -1105.897)",
    fill: "#111e72"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImgCar);
export default __webpack_public_path__ + "static/media/banner_img_car.7e5626dc882fabe43c1efb695f78ea18.svg";
export { ForwardRef as ReactComponent };